export const DEFAULT = 'default';

export const HierarchyLevel = Object.freeze({
	EPIC: 1,
	BASE: 0,
	SUBTASK: -1,
});
